import '../question_comments';
import '../question_courses';
import '../question_lessons';
import '../question_maintenance';
import '../question_notebooks';
import '../question_notes';
import '../question_notify';
import '../question_statistics';
import '../question_teacher';
import './index.scss';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import NotSubscribedUserModal from 'components/modals/not_subscribed_user_modal';
import Study from 'utils/study/study';
import feedbacks from 'utils/permissions/feedbacks';
import { EventManager } from 'utils/event_manager';
import { MediaQuery } from 'utils/media_query';
import { runFreemiumBlockMessageScript } from 'components/freemium/block_message';

class QuestionBelt {
  static start() {
    const $component = $('.q-question-belt');
    const $tooltips = $('[data-toggle="tooltip"]', $component);

    if (MediaQuery.is('lt_sm')) {
      $tooltips.each((i, el) => $(el).tooltip('disable'));
    }

    const experimentQuestionBeltBlockIsActive =
      gon.flags.question_belt_block.visible;

    if (!experimentQuestionBeltBlockIsActive) {
      $('#question_commented_feedback', $component)
        .off('click.permissions')
        .on('click.permissions', event => {
          QuestionBelt.commentedFeedback(event);
        });
    }

    $('.nav-tabs a', $component)
      .off('shown.bs.tab')
      .on('shown.bs.tab', e => {
        if (!$('body').data().isUserSignedIn) {
          const $link = $(e.currentTarget);

          $link.attr('aria-expanded', false);
          $link.parent().removeClass('active');

          $($link.attr('href')).removeClass('active');

          return;
        }

        const isShowPath = $component.data('is-show-path');

        const experimentQuestionBeltLimit = gon.flags.question_belt_limits;

        const questionBeltBlockInShow =
          experimentQuestionBeltLimit.QuestionBeltBlockInShow;

        const $tab = $(e.currentTarget);

        const { disabled, componentName, hasComments } = $tab.data();

        if (
          questionBeltBlockInShow &&
          isShowPath &&
          window.currentUser.subscriptionStatus === 'standard' &&
          ['question_comments', 'question_teacher'].includes(componentName)
        ) {
          const parseComponentNameToModalStandard = {
            question_comments: 'question_comments',
            question_teacher: 'commented_feedback'
          };

          new NotSubscribedUserModal(
            '#js-not-subscribed-user-modal',
            parseComponentNameToModalStandard[componentName]
          );

          const restrictedResource =
            feedbacks.utils.getEventResourceLimitSlug(componentName);

          feedbacks._sendAnalytics({
            'resouce limited': restrictedResource
          });

          return QuestionBelt.closeTab($component);
        }

        const RESOURCES_WITH_LIMITS = [
          'question_comments',
          'question_statistics'
        ];

        if (gon.flags.experiment_questionbelt_limit.active) {
          RESOURCES_WITH_LIMITS.push('question_teacher', 'question_lessons');
        }

        if (disabled) {
          if (
            experimentQuestionBeltBlockIsActive &&
            RESOURCES_WITH_LIMITS.includes(componentName)
          ) {
            feedbacks.questionBeltBlock();

            return QuestionBelt.closeTab($component);
          }
        }

        if (RESOURCES_WITH_LIMITS.includes(componentName)) {
          if (componentName === 'question_comments' && !hasComments) {
            QuestionBelt.loadTab(
              $tab.parents('.q-question-belt'),
              componentName,
              true
            );

            return;
          }

          if (gon.flags.experiment_questionbelt_limit.active) {
            QuestionBelt.checkQuestionLimitsWithoutLoading(e);
            return;
          }

          QuestionBelt.checkQuestionLimits(e);

          return;
        }

        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true
        );
      });

    $('.js-tab-close-btn', $component)
      .off('click')
      .on('click', e => {
        const $button = $(e.currentTarget);

        if ($button.hasClass('js-tab-close-btn-bottom')) {
          $('html, body').animate(
            {
              scrollTop: $button.parents('.js-question-item').offset().top - 20
            },
            200
          );
        }

        QuestionBelt.closeTab($component);

        EventManager.publish('questionBelt.tabClosed', {
          $tabPane: $button.parent('.tab-pane')
        });
      });
  }

  static closeTab($component) {
    $('.nav-tabs .active', $component).removeClass('active');
    $('.nav-tabs [data-toggle="tab"]', $component).attr('aria-expanded', false);
    $('.tab-pane.active', $component).removeClass('active');
    $(
      '.tab-pane .js-content.js-uncachable.q-component-loaded',
      $component
    ).removeClass('q-component-loaded');
  }

  static disableTab($tab) {
    const $container = $('.js-content', $tab.attr('href'));
    const $tabs = $('.q-question-belt-tabs', $container);

    $tab.data('aria-expanded', false);
    $tab.parent('.active').removeClass('active');
    $container.parent().removeClass('active');
    $tabs.removeClass('disabled');
  }

  static showFreemiumPaywall($tab) {
    const $container = $('.js-content', $tab.attr('href'));

    $container.find('.q-question-tab-content').hide();
  }

  static loadTab(context, componentName, force = false, reached = false) {
    const $component = context;
    const $tab = $(`[data-component-name="${componentName}"]`, $component);
    const $container = $('.js-content', $tab.attr('href'));
    const $tabs = $('.q-question-belt-tabs', $container);
    const tabData = $tab.data();
    const questionId = parseInt($component.data('question-id'));
    const totalComments = parseInt($component.data('total-comments'));
    const productKey = $component.data('product-key');
    const productSlug = $component.data('product-slug');
    const productId = $component.data('product-id');
    const alreadySolved = $component.data('already-solved');
    const isShowPath = $component.data('is-show-path');
    const $ctaPulse = $(`.cta-pulse.js-${questionId}-has-comments`, $component);

    if ($ctaPulse && componentName === 'question_comments') {
      $ctaPulse.addClass('hidden');
    }

    const { hasDefinitiveFeedback, urlFeedbackJustification, hasComments } =
      tabData;

    if (force || !$container.hasClass('q-component-loaded')) {
      const data = {
        question_id: questionId,
        product_id: productId,
        product_key: productKey,
        product_slug: productSlug,
        already_solved: alreadySolved,
        has_definitive_feedback: hasDefinitiveFeedback,
        url_feedback_justification: urlFeedbackJustification,
        show_path: isShowPath,
        limit_reached: reached,
        has_comments: hasComments,
        total_comments: totalComments
      };

      $tabs.addClass('disabled');

      AjaxComponentLoader.load({
        target: $container,
        component: `questions/${tabData.componentName}`,
        type: 'page_component',
        asset_key: null,
        data: data
      })
        .then(() => {
          const hasFreemiumBlockMessage = $('.q-freemium-block-message');

          global.blazyInstance.revalidate();

          EventManager.publish('questionBelt.tabLoaded', {
            questionId,
            $tabPane: $container.parent('.tab-pane')
          });

          if (hasFreemiumBlockMessage.length > 0) {
            runFreemiumBlockMessageScript();
          }
        })
        .catch(() => {
          QuestionBelt.disableTab($tab);
        });
    }
  }

  static commentedFeedback(event) {
    const { proceed, reason } = window.permissions.hasPermissions([
      'account',
      'confirmed_account',
      'commented_feedback_enabled'
    ]);

    if (proceed) {
      return;
    }

    event.detail = {
      type: 'commented_feedback'
    };

    window.permissions.feedbacks[reason](event);

    if (!window.currentUser) {
      return;
    }

    UserTracker.emit('event', {
      eventName: 'professor feedback clicked',
      data: {
        source_project: 'odin',
        request_path: window.location.pathname
      }
    });

    if (reason !== 'commented_feedback_enabled') {
      UserTracker.emit('event', {
        eventName: 'account restriction reached',
        data: {
          'resource restricted': 'commented feedback'
        }
      });
    }
  }

  // method create for use in experiment_questionbelt_limit
  static checkQuestionLimitsWithoutLoading(event) {
    const $tab = $(event.currentTarget);
    const { componentName } = $tab.data();

    if (
      componentName === 'question_lessons' ||
      componentName === 'question_teacher'
    ) {
      QuestionBelt.checkLimitAndShowModal(event, componentName);
      return;
    }

    Study.track(
      componentName,
      () => {
        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true
        );
      },
      ({ response }) => {
        const shouldDisplayPaywall =
          response.status === 422 ||
          window.currentUser.subscriptionStatus === 'standard';

        if (shouldDisplayPaywall) {
          feedbacks.commentsLimitModalSimple(event);
          return QuestionBelt.closeTab($tab.parents('.q-question-belt'));
        }

        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true,
          shouldDisplayPaywall
        );
      }
    );
  }

  static checkQuestionLimits(event) {
    const $tab = $(event.currentTarget);
    const { componentName } = $tab.data();

    /*
     * If check_limit API returns a success response, we just load the tab and follow with the render
     * If we receive an error from API, we hide the tabs and displays the modal limit (when API return limit_reached in the response body)
     */
    Study.track(
      componentName,
      () => {
        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true
        );
      },
      ({ response }) => {
        const shouldDisplayPaywall =
          response.status === 422 ||
          window.currentUser.subscriptionStatus === 'standard';

        if (shouldDisplayPaywall) {
          feedbacks.questionBeltLimit(componentName);
        }

        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true,
          shouldDisplayPaywall
        );
      }
    );
  }

  static shouldLoadTabWithoutLimits(componentName, hasComments, $tab) {
    if (componentName === 'question_comments' && !hasComments) {
      return true;
    }

    if (
      componentName === 'question_teacher' &&
      gon.flags.experiment_questionbelt_limit.active
    ) {
      const tabText = $tab.text().trim();
      const tabNumbers = tabText.match(/\d+/g);
      const tabCount = tabNumbers ? parseInt(tabNumbers[0]) : 0;

      return tabCount === 0;
    }

    return false;
  }

  static checkLimitAndShowModal(event, componentName) {
    const $tab = $(event.currentTarget);
    const userId = window.currentUser?.id;

    if (!userId) {
      return;
    }

    const apiUrl = `/api/users/${userId}/used_resources/summary`;

    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    })
      .then(response => response.json())
      .then(data => {
        const resourceTypeMap = {
          question_lessons: 'lessons',
          question_teacher: 'teachers'
        };
        const resourceType = resourceTypeMap[componentName];
        const resourceData = data.summary?.resources?.[resourceType];
        const tabText = $tab.text().trim();
        const tabNumbers = tabText.match(/\d+/g);
        const tabCount = tabNumbers ? parseInt(tabNumbers[0]) : 0;

        if (
          resourceData &&
          resourceData.used >= resourceData.threshold &&
          tabCount > 0
        ) {
          const modalMethodMap = {
            question_lessons: () => feedbacks.lessonsLimitModalSimple(event),
            question_teacher: () =>
              feedbacks.questionTeacherLimitModalSimple(event)
          };
          const modalMethod = modalMethodMap[componentName];

          modalMethod();
          return QuestionBelt.closeTab($tab.parents('.q-question-belt'));
        }

        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true
        );
      })
      .catch(() => {
        QuestionBelt.loadTab(
          $tab.parents('.q-question-belt'),
          componentName,
          true
        );
      });
  }
}

(function () {
  'use strict';
  window.QuestionBelt = QuestionBelt;
  window.QuestionBelt.start();
})(jQuery);
